import React from "react";
import CampaignEventList from "./campaignEventList/CampaignEventList";

const CampaignEvent = () => {
  return <CampaignEventList />;
};

export default CampaignEvent;
